/* Hook encargado de hacer la consulta a la base y 
traer los modelos de los vehiculos. Todos

Autor: Benjamín León
Fecha: 2024-08-25
*/
import { useState } from 'react'

import { customFetch } from '../utils/customFetch.ts'
import Model from '../interfaces/Model.ts'

import { makeUrlModels } from './connectionData.tsx'

const useModelsFetcher = () => {
  const [errorModels, setErrorModels] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const fetchModels = async () => {
    setLoading(true)

    try {
      const apiUrl = makeUrlModels()
      const data = await customFetch<Model[]>(apiUrl)
      setErrorModels(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorModels(err)
      } else {
        setErrorModels(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorModels, loading, fetchModels }
}

export default useModelsFetcher
